import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
};

const Icon: React.FC<Props> = ({ className, width = '36', height = '36' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 36 36"
    className={className}
  >
    <mask
      id="mask0_16414_9693"
      style={{ maskType: 'alpha' }}
      width={width}
      height={height}
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H36V36H0z"></path>
    </mask>
    <g mask="url(#mask0_16414_9693)">
      <path
        fill="#D6A124"
        d="M5.138 30.75c-.254 0-.483-.063-.685-.187a1.316 1.316 0 01-.472-.491 1.432 1.432 0 01-.193-.657 1.224 1.224 0 01.19-.7L16.82 6.534A1.344 1.344 0 0118 5.855a1.344 1.344 0 011.18.678l12.842 22.183c.139.23.203.464.19.7a1.432 1.432 0 01-.192.656c-.113.203-.27.367-.472.491-.203.124-.431.187-.686.187H5.139zm1.537-2.25h22.65L18 9 6.675 28.5zM18 26.71c.343 0 .63-.116.863-.348.232-.232.348-.52.348-.863 0-.344-.116-.631-.348-.864a1.172 1.172 0 00-.863-.348c-.344 0-.631.116-.864.348-.232.233-.348.52-.348.864 0 .343.116.63.348.863.233.232.52.348.864.348zm0-3.923c.319 0 .586-.108.802-.323a1.09 1.09 0 00.323-.802v-5.25c0-.319-.108-.586-.324-.802a1.09 1.09 0 00-.802-.323c-.319 0-.586.108-.801.323a1.09 1.09 0 00-.323.802v5.25c0 .319.108.586.323.802.216.215.483.323.802.323z"
      ></path>
    </g>
  </svg>
);

export default Icon;
